import gql from 'graphql-tag'

export default gql`mutation editProjectClientInvoiceValue($client_id: Int!, $project_activity_budget_id: Int, $description: String!, $amount: Float!) {
    editProjectClientInvoiceValue(client_id: $client_id, project_activity_budget_id: $project_activity_budget_id, description: $description, amount: $amount) @client
}`